import axiosInstance from '../RestClient';

const contractTemplateService = {
	list: (params = {}) => axiosInstance.get('/contractTemplates', { params }),
	getDetails: (id) => axiosInstance.get(`/contractTemplates/${id}`),
	create: (data) => axiosInstance.post('/contractTemplates', data),
	edit: (id, data) => axiosInstance.put(`/contractTemplates/${id}`, data),
	saveDraft: (id, content) => axiosInstance.put(`/contractTemplates/draft/${id}`, { content }),
	delete: (id) => axiosInstance.delete(`/contractTemplates/${id}`),
	createShareLink: ({ templateId, entityType, entityId, format }) =>
		axiosInstance.post(`/contractTemplates/share/${templateId}`, { entityType, entityId, format }),
	getEntityPhone: ({ entityType, entityId }) =>
		axiosInstance.get('/contractTemplates/entity-phone', { params: { entityType, entityId } }),
	getVariables: () => axiosInstance.get('/contractTemplates/variables'),
};

export default contractTemplateService;
